<template>
    <div class="menu-wrapper" :class="[$store.state.openMenu ? 'active' : '']">
        <el-menu class="el-menu-vertical-demo" background-color="#324155" text-color="#fff" router
            :default-active="$route.path" @select="selectMenu" active-text-color="#409EFF">
            <span class="logtitle">NoWait System</span>
            <el-menu-item key="home" index="home">
                <font-awesome-icon icon="fa-solid fa-chart-line" />
                <span slot="title" :style="'margin-left:8px'">{{ $t('overview') }}</span>
            </el-menu-item>

            <el-submenu :index="index + ''" v-for="(item, index) in menu" :key="index" v-if="item.visible === '1'">
                <template slot="title">
                    <div :style="item.color == 1 ? 'background-color:coral;margin-left: -12%;margin-right: -12%;' : ''">
                        <!--<i  :style="item.color==1?'margin-left: 10%;':''" class="el-icon-menu"></i>-->
                        <font-awesome-icon :icon="item.icon" />
                        <span :style="'margin-left:8px'">{{ item.label }}</span>
                    </div>
                </template>
                <el-menu-item-group>
                    <el-menu-item v-for="child in item.children" :key="child.path"
                        :index="child.path" v-if="child.visible == '1'">
                        <template>
                            {{ child.label }}
                        </template>
                    </el-menu-item>
                </el-menu-item-group>
            </el-submenu>
        </el-menu>
    </div>
    
</template>
<script>
export default {
    data() {
        return {
            root_management: "0",
            store_management: "0",
            membership_read: "0",
            broadcasting_read: "0",
            coupon_read: "0",
            chatbot_setting_read: "0",
            chatbot_message_read: "0",
            product_setting_read: "0",
            order_read: "0",
            payment_read: "0",
            booking_read: "0",
            menu: [
                // {
                //     label: this.$t('overview'),
                //     children: [
                //         {label: this.$t('Home'), path: '/home'}


                //     ]
                // },
                {
                    label: this.$t('allRecords'),
                    icon: 'fa-solid fa-user',
                    children: [

                        /* {label: this.$t('TemplateList'), path: '/template'},
                         {label: this.$t('guanfangTemplateList'), path: '/guanfang'},*/
                        { label: this.$t('memberGroup'), path: '/pendingList', visible: 0 },
                        /* {label: this.$t('kehulist'), path: '/kehu'}, */
                        { label: this.$t('kehulist'), path: '/userList', visible: 0 }

                    ],
                    color: 0,
                    visible: 0
                },
                {
                    label: this.$t('renwuhis'),
                    icon: 'fa-solid fa-podcast',
                    children: [

                        /*{label: '群發訊息範本', path: '/template'},*/
                        /*{label: this.$t('guanfangTemplateList'), path: '/guanfang'},*/
                        { label: this.$t('renwulist'), path: '/renwulist', visible: 0 }
                        /*
                        {label:  this.$t('renwuhis'), path: '/tongyong2'}*/

                    ],
                    color: 0,
                    visible: 0
                },
                {
                    label: this.$t('electronicCoupon'),
                    icon: 'fa-solid fa-tag',
                    children: [

                        { label: this.$t('huodonglist'), path: '/huodong', visible: 0 },
                        { label: this.$t('huodonglist'), path: '/huodong2', visible: 1 }

                    ],
                    color: 0,
                    visible: 0
                },
                {
                    label: this.$t('chatbot'),
                    icon: 'fa-solid fa-message',
                    children: [
                        { label: this.$t('autoTemplate'), path: '/autoTemplate', visible: 0 },
                        { label: this.$t('metaTemplate'), path: '/metaTemplate', visible: 0 },
                        /*	{label:  this.$t('backmsglist') , path: '/backmsg'},*/
                        { label: this.$t('backmsglist'), path: '/history', visible: 0 },
                        /*{ label: this.$t('backmsglist'), path: '/history2', visible: 0 },*/
                    ],
                    color: 0,
                    visible: 0
                },
                {
                    label: this.$t('productManagement'),
                    icon: 'fa-solid fa-store',
                    children: [
                        { label: this.$t('productList'), path: '/product', visible: 0 },
                        { label: this.$t('orderRecords'), path: '/order', visible: 0 },
                        { label: this.$t('paymentRecords'), path: '/payment', visible: 0 },
                      //  { label: this.$t('fpsSettlementRecord'), path: '/fpshistory', visible: 1 },
                       // { label: this.$t('fpsSettlementRecordSim'), path: '/fpshistorysim', visible: 1 },
                    ],
                    color: 0,
                    visible: 0
                },
                /*
                {
                    label:  this.$t('waitsystem') ,
                    children: [
                      
                        {label:  this.$t('qiyelist') , path: '/messenger'},
                        {label:  this.$t('datasys')  , path: '/chart'},
                    
                        // {label: '叫号系统', path: '/jiaohao'},
                    ],
                    color:0
                },		
                {
                    label: 'WhatsShop',
                             
                    children: [
                	
                     
                       
                          {label:  this.$t('Productlist'), path: '/tongyong/messenger_product'},
                        {label:  this.$t('orderlist'), path: '/tongyong/messenger_orderlist'}
                      
                    ],
                    color:0
                },*/
                /*
                {
                    label: this.$t('FinancialManagement'),
                    children: [
                        {label: this.$t('rechargeRecord'), path: '/financialManagement'},
                        // {label: this.$t('invoiceRecord'), path: '/invoiceRecord'},
                        {label: this.$t('PackagePurchase'), path: '/corporateInformation/packagePurchase'},
                        // {label: this.$t('tuijian'), path: '/tuijian'}
                    ],
            	
                },*/
                {
                    label: this.$t('bookingManagement'),
                    icon: 'fa-solid fa-calendar-days',
                    children: [
                        /*{label:  this.$t('qiyelist') , path: '/messenger'},*/
                        { label: this.$t('bookingRecord'), path: '/bookingrecord', visible: 1 },

                    ],
                    color: 0,
                    visible: '1'
                },
                {
                    label: this.$t('systemSetting'),
                    icon: 'fa-solid fa-gear',
                    children: [
                        /*{label:  this.$t('qiyelist') , path: '/messenger'},*/
                        { label: this.$t('storelist'), path: '/store', visible: 0 },
                        { label: this.$t('userProfileSettings'), path: '/userSettings', visible: 0 },
                        { label: this.$t('ModifyData'), path: '/corporateInformation', visible: 0 },
                        { label: this.$t('changePassword'), path: '/changePassword', visible: 0 },
                       /* { label: this.$t('topup'), path: '/topup', visible: 0 },*/
                        { label: this.$t('quite'), path: '/login', visible: '1' },

                    ],
                    color: 0,
                    visible: '1'
                }
            ]
        }
    },
    created() {
        var auser = JSON.parse(window.localStorage.getItem('auserinfo'))
        this.store_management = auser.store_management;
		this.membership_read = auser.membership_read;
        this.broadcasting_read = auser.broadcasting_read;
        this.coupon_read = auser.coupon_read;
        this.chatbot_setting_read = auser.chatbot_setting_read;
        this.chatbot_message_read = auser.chatbot_message_read;
        this.product_setting_read = auser.product_setting_read;
        this.order_read = auser.order_read;
        this.payment_read = auser.payment_read;
        this.booking_read = auser.booking_read;
        this.menu[0]['visible'] = auser.membership_read;
        this.menu[0]['children'][0]['visible'] = auser.membership_read;
        this.menu[0]['children'][1]['visible'] = auser.membership_read;
        this.menu[1]['visible'] = auser.broadcasting_read;
        this.menu[1]['children'][0]['visible'] = auser.broadcasting_read;
        this.menu[2]['visible'] = auser.coupon_read;
        this.menu[2]['children'][0]['visible'] = auser.coupon_read;
        if(auser.chatbot_setting_read === '1' || auser.chatbot_message_read === '1') {
            this.menu[3]['visible'] = '1';
        }
        this.menu[3]['children'][0]['visible'] = auser.chatbot_setting_read;
        this.menu[3]['children'][1]['visible'] = auser.chatbot_setting_read;
        this.menu[3]['children'][2]['visible'] = auser.chatbot_message_read;
        //this.menu[3]['children'][3]['visible'] = auser.chatbot_message_read;
        if(auser.product_setting_read === '1' || auser.order_read === '1' || auser.payment_read === '1') {
            this.menu[4]['visible'] = '1';
        }
        this.menu[4]['children'][0]['visible'] = auser.product_setting_read;
        this.menu[4]['children'][1]['visible'] = auser.order_read;
        this.menu[4]['children'][2]['visible'] = auser.payment_read;
        //this.menu[4]['children'][3]['visible'] = auser.store_management;
        //this.menu[4]['children'][4]['visible'] = auser.store_management;
        this.menu[5]['visible'] = auser.booking_read;
        this.menu[5]['children'][0]['visible'] = auser.booking_read; /* booking */
        this.menu[6]['children'][0]['visible'] = auser.store_management;
        this.menu[6]['children'][1]['visible'] = (auser.store_management === '1' || auser.root_management === '1') ? '1' : '0';
        this.menu[6]['children'][2]['visible'] = auser.root_management;
        this.menu[6]['children'][3]['visible'] = auser.root_management;
        this.menu[6]['children'][4]['visible'] = auser.store_management;
    },
    methods: {
        selectMenu() {
            if (this.$store.state.isMobile) {
                this.$store.commit('setOpenMenu')
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.child-item .el-menu-item .el-submenu__title {
    background-color: #1F2D3D !important;
    max-width: 100% !important;
    white-space: normal !important;
    word-wrap: break-word !important;
}

.el-submenu {
    background-color: #1F2D3D !important;
}

.logtitle {
    color: aliceblue;
    margin-top: 30px;
    margin: 20px;
    height: 30px;
    line-height: 30px;
}

.menu-wrapper {
    width: 250px;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    transition: all .6s;
    .el-menu-vertical-demo {
        height: 100%;
        width: 100%;
    }
}

@media screen and (max-width: 768px) {
    .menu-wrapper {
        transform: translateX(-400px);
        z-index: 50;

        &.active {
            transform: translateX(0px);
        }
    }

    ::v-deep .el-menu {
        border-right: none;
    }
}
</style>